import CrownIcon from '../assets/icons/crownIcon';
import RightArrowIcon from '../assets/icons/rightArrow';
import {
	Indiaflag,
	BackImage1,
	aboutlogo,
	heroImage,
	logo2_bg,
	logo3_bg,
	logo5_bg,
	logo6_bg,
	logo4_bg,
	about_logo,
	home_main_mobile,
	homemain,
	Usaflag,
	uae_about,
	usa_about,
} from '../assets/images';
import Navbar from '../components/Navbar';
import { useEffect, useState } from 'react';
import Footer from '../components/Footer';
import DashedBorder from '../assets/icons/border';
import { useNavigate } from 'react-router-dom';
import Downloadbroch from '../components/Downloadbroch';

const AboutUs = () => {
	const stats = [
		{ value: '50+', label: 'Exclusive Clients' },
		{ value: '10+', label: 'Years of Experience' },
		{ value: '1200+', label: 'Hard-working Staff', shortLabel: 'Staff' },
		{ value: '24/7', label: 'Working Capacity' },
	];
	const [isSmallScreen, setIsSmallScreen] = useState(false);
	const [isMdUp, setIsMdUp] = useState(window.innerWidth >= 768);
	const iconSize = isSmallScreen ? 20 : 24;
	const navigate = useNavigate();

	const testimonialsData = [
		{
			id: 1,
			logo: aboutlogo,
			location: 'India',
			flag:Indiaflag,
			quote: '"Zecca has been a reliable supplier for us. The bags are strong, well-made, and exactly what we need for our products."',
			author: 'John Doe',
		},
		{
			id: 2,
			logo: logo2_bg,
			location: 'UAE',
			flag:uae_about,
			quote: '"Great quality and finishing! The bags look premium and have proven durable across our stores. Customers appreciate the sturdy design too."',
			author: 'John Doe',
		},
		{
			id: 3,
			logo: logo3_bg,
			location: 'India',
			flag:Indiaflag,
			quote: '"We’ve been sourcing carry bags from Zecca for over three years—top-notch quality, quick service, and great customization options!"',
			author: 'John Doe',
		},
		{
			id: 4,
			logo: logo4_bg,
			location: 'India',
			flag:Indiaflag,
			quote: '"The packaging aligns well with our standards: dependable, well-crafted, and delivered without fuss."',
			author: 'John Doe',
		},
		{
			id: 5,
			logo: logo5_bg,
			location: 'India',
			flag:Indiaflag,
			quote: '"Really impressed with the quality and detailing of the packaging. It perfectly matches the elegance and standards we maintain at Kalamandir Jewellers."',
			author: 'John Doe',
		},
		{
			id: 6,
			logo: logo6_bg,
			location: 'USA',
			flag:usa_about,
			quote: '"Appreciate the consistency and quality across every shipment. The bags are durable, well-stitched, and perfectly suited for bulk retail packaging."',
			author: 'John Doe',
		},
	];
	const [isPaused, setIsPaused] = useState(false);
	useEffect(() => {
		const handleResize = () => setIsMdUp(window.innerWidth >= 768);
		window.addEventListener('resize', handleResize);
		return () => window.removeEventListener('resize', handleResize);
	}, []);
	useEffect(() => {
		const handleResize = () => {
			setIsSmallScreen(window.innerWidth < 640);
		};

		handleResize();
		window.addEventListener('resize', handleResize);

		return () => window.removeEventListener('resize', handleResize);
	}, []);

	return (
		<div className="w-full">
			{/* <div className="relative overflow-hidden">
				<div
					className="relative flex justify-center items-center h-[689px] xl:h-[566px] lg:h-[566px] md:h-[566px] sm:h-[689px] w-full"
					style={{
						backgroundImage: isSmallScreen
							? `
							linear-gradient(225.42deg, #000000 19.01%, rgba(0, 0, 0, 0) 28.12%, rgba(0, 0, 0, 0) 36.49%, rgba(0, 0, 0, 0.80) 47.51%, #000000 81.02%),
							linear-gradient(180deg, #000000 0%, rgba(0, 0, 0, 0) 14.91%, rgba(0, 0, 0, 0) 100%),
							url(${home_main_mobile})
							`
							: `
							linear-gradient(256.37deg, #000000 0%, rgba(0, 0, 0, 0) 14.68%, rgba(0, 0, 0, 0) 28.19%, rgba(0, 0, 0, 0.76) 66.31%, #000000 100%),
							linear-gradient(180deg, #000000 0%, rgba(0, 0, 0, 0) 14.91%, rgba(0, 0, 0, 0) 100%),
							url(${homemain})
							`,
						backgroundRepeat: 'no-repeat',
						backgroundPosition: 'center',
						backgroundSize: 'cover',
					}}
				>
					<Navbar />
					<span className="absolute max-w-[1400px] xl:w-[1400px] lg:w-[900px] md:w-[700px] sm:w-[393px] ms:w-full xs:w-full xl:pl-[100px] lg:pl-0 md:pl-0 sm:pl-0 ms:pl-[20px] xs:pl-[20px] flex flex-col justify-center">
						<h2 className="text-white xl:font-medium lg:font-medium md:font-medium sm:font-bold ms:font-bold xs:font-bold xl:text-[60px] lg:text-[60px] md:text-[32px] sm:text-[32px] text-[32px] leading-[140%] shadow-[0_4px_20px_0_#0000001F] flex items-center justify-start text-left text-goudy pt-[90px] sm:pt-[90px] md:pt-0 lg:pt-0 xl:pt-0">
							About Us
						</h2>
						<p className="w-[252px] sm:w-[252px] md:w-[300px] lg:w-[405px] xl:w-[405px] h-[64px] opacity-100 text-white font-normal text-[14px] sm:text-[14px] md:text-[14px] lg:text-[18px] xl:text-[18px] leading-[180%] shadow-[0_4px_20px_0_#0000001F] flex items-start justify-start text-left xl:mt-4 lg:mt-4 md:mt-4 sm:mt-[12px] mt-[12px] font-google">
							Delivering quality, sustainability, and trust across
							every product we make.
						</p>
					</span>
				</div>
			</div> */}
			<div className="relative overflow-hidden">
				<div
					className="relative flex justify-center items-center h-[689px] xl:h-[566px] lg:h-[566px] md:h-[566px] sm:h-[689px] w-full"
					style={{
						backgroundImage: isSmallScreen
							? `url(${home_main_mobile})`
							: `url(${homemain})`,
						backgroundRepeat: 'no-repeat',
						backgroundPosition: 'center',
						backgroundSize: 'cover',
					}}
				>
					<div
						className="absolute inset-0 pointer-events-none "
						style={{
							 opacity: isSmallScreen ? "0.8" : "1",
							background: isSmallScreen
								? `
							linear-gradient(225.42deg, rgb(0, 0, 0) 1.01%, rgba(0, 0, 0, 0) 5.12%, rgba(0, 0, 0, 0) 21.49%, rgba(0, 0, 0, 0.76) 51.51%, rgb(0, 0, 0) 76.02%), linear-gradient(rgb(0, 0, 0) 0%, rgba(0, 0, 0, 0) 19.91%, rgba(0, 0, 0, 0) 100%)
							`
				
													: `
							linear-gradient(256.37deg, #000000 0%, rgba(0, 0, 0, 0) 14.68%, rgba(0, 0, 0, 0) 28.19%, rgba(0, 0, 0, 0.76) 66.31%, #000000 100%),
							linear-gradient(180deg, #000000 0%, rgba(0, 0, 0, 0) 14.91%, rgba(0, 0, 0, 0) 100%)
							`
						}}
					></div>

					<Navbar />

					<span className="absolute max-w-[1400px] xl:w-[1400px] lg:w-[900px] md:w-[700px] sm:w-[393px] ms:w-full xs:w-full xl:pl-[100px] ms:px-[20px] xs:px-[20px] flex flex-col justify-center">
						<h2 className="text-white xl:font-medium lg:font-medium md:font-medium sm:font-bold ms:font-bold xs:font-bold xl:text-[60px] lg:text-[60px] md:text-[32px] sm:text-[32px] text-[32px] leading-[140%] shadow-[0_4px_20px_0_#0000001F] flex items-center justify-start text-left text-goudy pt-[90px] sm:pt-[90px] md:pt-0 lg:pt-0 xl:pt-0">
							About Us
						</h2>
						<p className="w-[252px] sm:w-[252px] md:w-[300px] lg:w-[405px] xl:w-[405px] h-[64px] opacity-100 text-white font-normal text-[14px] sm:text-[14px] md:text-[14px] lg:text-[18px] xl:text-[18px] leading-[180%] shadow-[0_4px_20px_0_#0000001F] flex items-start justify-start text-left xl:mt-4 lg:mt-4 md:mt-4 sm:mt-[12px] mt-[12px] font-google">
							Delivering quality, sustainability, and trust across
							every product we make.
						</p>
					</span>
				</div>
			</div>
			<div
				className={`relative flex flex-col items-center  xl:h-[845px] lg:h-[760px] md:h-[700px] sm:h-[641px] ms:h-[640px] xs:h-[690px] w-full 
				${isMdUp ? 'bg-contain' : 'bg-[#EBEBE666]'}`}
				style={{
					backgroundImage: isMdUp ? `url(${BackImage1})` : 'none',
					backgroundRepeat: 'no-repeat',
					backgroundSize: 'auto',
					backgroundPosition: 'center bottom',
				}}
			>
				<div className="xl:w-[898px] lg:w-[700px] md:w-[580px] w-[90%] flex flex-col opacity-100 xl:pt-[142px] lg:pt-[80px] md:pt-[80px] sm:pt-[60px] pt-[60px]">
					<div className="w-full flex items-center justify-center opacity-100">
						<img
							src={about_logo}
							alt="ZECCA Logo"
							className="object-contain xl:h-[206px] xl:w-[898px] lg:h-[206px] lg:w-[898px] md:h-[120px] md:w-[898px] sm:h-[58px] h-[58px] sm:w-[289px] w-[289px]"
						/>
					</div>

					<div className="flex flex-col md:flex-row justify-between items-center text-center md:text-left xl:pt-[9px] lg:pt-[9px] md:pt-[9px] sm:pt-[18px] pt-[18px] xl:w-full lg:w-full md:w-full sm:w-full ms:w-full xs:w-full h-fit">
						<span className="text-black text-[14px] sm:text-[14px] xl:text-[16px] lg:text-[16px] md:text-[14px] leading-[150%] font-google font-normal">
							Believe. Behave. Become.
						</span>
						<button
							className="xl:w-[209px] lg:w-[209px] md:w-[190px] h-[47px] hidden md:flex items-center justify-center gap-[10px] rounded-[30px] bg-black cursor-pointer text-white text-[14px] xl:text-[16px] lg:text-[16px] md:text-[14px] font-google font-[500] leading-[100%]"
							style={{
								boxShadow: '0px 4px 20px 0px #0000001F',
							}}
							onClick={() => navigate('/products')}
						>
							Explore Products
							<RightArrowIcon />
						</button>
					</div>

					<div className="flex flex-col w-full items-center text-center sm:text-center md:text-left">
						<p className="opacity-100 font-google font-normal text-[14px] xl:text-[16px] lg:text-[16px] md:text-[14px] sm:text-[14px] text-[14px] xl:leading-[150%] lg:leading-[150%] md:leading-[150%] sm:leading-[180%] leading-[180%] tracking-[0%]  xl:w-[898px] lg:w-[700px] md:w-[580px] sm:w-[353px] ms:w-full xs:w-full xl:pt-[56px] lg:pt-[56px] md:pt-[50px] sm:pt-[18px] pt-[18px]">
							At Zecca Pac, we are committed to creating
							sustainable and high-quality non-woven solutions
							that power modern industries. Based in India, we
							specialize in manufacturing a wide range of
							non-woven materials designed for diverse
							applications, from eco-friendly carry bags and
							pharmaceutical packaging to agricultural covers and
							fabrics. With advanced technology, strict quality
							standards, and a focus on environmental
							responsibility, Zecca Pac delivers products that
							combine durability, functionality, and
							sustainability. Our mission is to support businesses
							and communities with smarter, greener packaging and
							material solutions that shape a cleaner future.
						</p>
						<button
							className="md:hidden mt-[12px] w-[180px] h-[40px] flex items-center justify-center gap-[4px] rounded-[30px] bg-black shadow-[0px_4px_20px_0px_#0000001F] py-[10px] px-[20px] cursor-pointer text-white text-[14px] font-google font-[500] leading-[100%]"
							onClick={() => navigate('/products')}
						>
							Explore Products
							<RightArrowIcon
								width={iconSize}
								height={iconSize}
							/>
						</button>
					</div>
				</div>
			</div>
			<div className="w-full flex justify-center">
				<div className="xl:w-[1200px] lg:w-[900px] md:w-[600px] sm:w-[393px] ms:w-full xs:w-full xl:h-[995px] lg:h-[995px] md:h-[722px] sm:h-[722px] ms:h-[722px] xs:h-fit flex flex-col items-center xl:py-[120px] lg:py-[120px] md:py-[80px] sm:py-[60px] py-[60px]">
					<h1 className="text-goudy font-normal xl:text-[52px] lg:text-[52px] md:text-[50px] sm:text-[28px] text-[28px] leading-[120%] text-black ">
						Factory Insights
					</h1>
					<div
						className="xl:w-[1200px] xl:h-[510px] lg:w-[900px] lg:h-[510px] md:w-[600px] md:h-[510px] sm:w-[353px] ms:w-[350px] xs:w-[300px] sm:h-[353px] h-[353px] xl:mt-[40px] lg:mt-[40px] md:mt-[40px] sm:mt-[24px] mt-[24px] rounded-[24px] shadow-[0_4px_20px_0_#0000000F] opacity-100  relative"
						style={{
							backgroundImage: `url(${heroImage})`,
							backgroundSize: 'cover',
							backgroundRepeat: 'no-repeat',
							backgroundPosition: 'center center',
						}}
					></div>
					<div className="flex w-full xl:mt-[64px] lg:mt-[64px] md:mt-[40px] sm:mt-[25px] mt-[25px] bg-white grid xs:grid-cols-1 ms:grid-cols-2 sm:grid-cols-2 xl:grid-cols-4 lg:grid-cols-4 md:grid-cols-4 gap-5">
						{stats.map((stat, index) => (
							<div
								key={index}
								className="flex flex-col items-center gap-[12px]"
							>
								<CrownIcon
									width={iconSize}
									height={iconSize}
								/>
								<p className="xl:text-[16px] lg:text-[16px] md:text-[12px] text-[14px] leading-[120%] font-plusJakarta font-normal text-center whitespace-nowrap text-gray-800">
									{stat.value}{' '}
									{isSmallScreen && stat.shortLabel
										? stat.shortLabel
										: stat.label}
								</p>
								<div className="mt-2 xl:w-[285px] lg:w-[200px] md:w-[150px] w-[150px] h-[4px] bg-[#C4BAA3] rounded-[30px] opacity-100"></div>
							</div>
						))}
					</div>
				</div>
			</div>

			<div
				className={`relative flex flex-col items-center xl:h-[936px] lg:h-[900px] md:h-[800px] sm:h-[509px] h-[509px] w-full ${
					isMdUp ? 'bg-contain' : 'bg-[#EBEBE666]'
				}`}
				style={{
					backgroundImage: isMdUp ? `url(${BackImage1})` : 'none',
					backgroundRepeat: 'no-repeat',
					backgroundSize: 'auto',
					backgroundPosition: 'center bottom',
				}}
			>
				<div className="xl:pt-[140px] lg:pt-[100px] md:pt-[80px] sm:pt-[20px] pt-[20px] flex 2xl:w-[1200px] xl:w-[1200px] lg:w-[900px] md:w-[600px] sm:w-[393px] ms:w-full xs:w-full items-center 2xl:justify-between xl:justify-between lg:justify-between md:justify-between justify-center">
					<h1 className="text-goudy font-normal xl:text-[52px] lg:text-[52px] md:text-[30px] sm:text-[28px] text-[28px] leading-[120%] text-black pt-10 sm:pt-10 md:pt-0 lg:pt-0 xl:pt-0 2xl:pt-0">
						Client Testimonials
					</h1>
					<div
						className="hidden md:flex items-center justify-center gap-[10px] rounded-[30px] opacity-100 bg-black cursor-pointer text-white text-[14px] xl:text-[18px] lg:text-[16px] md:text-[14px] sm:text-[14px] font-google font-medium leading-[100%] tracking-[0%]"
						style={{
							padding: '10px 24px',
						}}
						onClick={() => navigate('/products')}
					>
						Explore Products
						<RightArrowIcon />
					</div>
				</div>

				<div className="relative w-full flex overflow-hidden bg-transparent pt-[40px]">
					<div
						// className="flex animate-scroll gap-4 md:gap-4"
						// style={{
						// 	width: `${
						// 		[...testimonialsData, ...testimonialsData]
						// 			.length * 400
						// 	}px`,
						// }}
						className="flex animate-scroll gap-4 md:gap-4"
						style={{
							width: `${
								[...testimonialsData, ...testimonialsData]
									.length * 400
							}px`,
							animationPlayState: isPaused ? 'paused' : 'running',
						}}
						onMouseEnter={() => setIsPaused(true)}
						onMouseLeave={() => setIsPaused(false)}
						onTouchStart={() => setIsPaused(true)}
						onTouchEnd={() => setIsPaused(false)}
					>
						{[...testimonialsData, ...testimonialsData].map(
							(testimonial, id) => (
								<div
									key={testimonial.id}
									className="xl:h-[434px] lg:h-[434px] md:h-[434px] sm:h-[258px] h-[258px] xl:w-[387px] lg:w-[387px] md:w-[387px] sm:w-[261px] w-[261px] flex-shrink-0 bg-white rounded-[24px] shadow-[0_4px_20px_0_#0000000F] relative"
								>
									<DashedBorder
										radiusDesktop={24}
										radiusMobile={24}
									/>
									<div className="flex flex-col xl:gap-3 lg:gap-3 md:gap-3 sm:gap-[12px] gap-[12px]">
										<div className="2xl:w-[120px] xl:w-[120px] lg:w-[100px] w-[82px] 2xl:h-[120px] xl:h-[120px] lg:h-[100px] h-[82px] xl:ml-[24px] lg:ml-[24px] md:ml-[24px] sm:ml-[16px] ml-[16px] xl:mt-[24px] lg:mt-[24px] md:mt-[24px] sm:mt-[16px] mt-[16px]">
											<img
												src={testimonial.logo}
												alt="Company Logo"
												className="w-full h-full object-contain"
											/>
										</div>
										<div className="flex items-center text-gray-600 gap-2 xl:pl-[24px] lg::pl-[24px] md::pl-[24px] sm:pl-[16px] pl-[16px]">
											<img
												src={testimonial.flag}
												alt="India Flag"
												className="w-[36px] h-[36px] rounded-[22px] object-auto"
											/>
											<p className="font-plusJakarta text-[#1D1D1D] font-medium 2xl:text-[18px] xl:text-[18px] lg:text-[18px] md:text-[18px] sm:text-[12px] text-[12px] leading-[32px] tracking-[0]">
												{testimonial.location}
											</p>
										</div>
									</div>
									<p className="font-[500] xl:text-[18px] 2xl:text-[18px] lg:text-[14px] md:text-[14px] sm:text-[12px] text-[12px] xl:leading-[32px] lg:leading-[32px] md:leading-[32px] sm:leading-[20px] leading-[20px] font-plusJakarta xl:pt-[24px] lg:pt-[24px] md:pt-[24px] sm:pt-[16px] pt-[16px] text-[#1D1D1D] xl:pl-[24px] xl:pr-[36px] lg:pl-[24px] lg:pr-[36px] md:pl-[24px] md:pr-[36px] sm:pl-[16px] sm:pr-[16px] pl-[16px] pr-[16px] tracking-[0]">
										{testimonial.quote}
									</p>
								</div>
							),
						)}
					</div>
				</div>
				<div className="w-full flex md:hidden justify-center pt-[28px] cursor-pointer">
					<div
						className="w-[175px] h-[40px] flex items-center justify-center gap-[4px] rounded-[30px] bg-black py-[10px] px-[20px] text-white text-[14px] font-google font-[500] leading-[100%] tracking-[0%]"
						onClick={() => navigate('/products')}
					>
						Explore Products
						<RightArrowIcon
							width={iconSize}
							height={iconSize}
						/>
					</div>
				</div>
			</div>
			<Downloadbroch />
			<Footer />
		</div>
	);
};
export default AboutUs;
